import useAccountDetails from 'modules/queries/account/useDetails';
import sendGtmEvent from '../sendGtmEvent';

export type HubspotEventType = 'ssl' | 'domain' | 'addon' | 'ticket';

export interface HubspotEventProps {
	serverUniqId?: string;
	serverHostName?: string;
	addOnName?: string;
}

const eventMap = {
	ssl: 'purchased_ssl',
	domain: 'purchased_transfer_domain',
	addon: 'purchased_backup_addon',
	ticket: 'new_support_ticket',
};

const useSendHubspotEvent = (
	eventType: HubspotEventType,
	options?: { enabled?: boolean },
) => {
	const { data } = useAccountDetails({}, { enabled: options?.enabled });
	const accountNumber = data?.accnt || '';

	return (props?: HubspotEventProps) => {
		sendGtmEvent({
			event: 'lw.event',
			eventName: eventMap[eventType],
			eventData: {
				accountNumber,
				system: 'lw',
				...props,
			},
		});
	};
};

export default useSendHubspotEvent;
